import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StructureLocationTreeComponent } from './structure-location-tree/structure-location-tree.component';
import {TreeResolver} from "./tree-resolver.service";
import {ChappsCommonAngularLibraryModule} from "@npm.chapps.com/chapps.common.angular.library";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {CommonsModule} from "../../../common/common.module";
import {StructureService} from '../structure.service';



@NgModule({
  declarations: [
    StructureLocationTreeComponent
  ],
    imports: [
        CommonModule,
        ChappsCommonAngularLibraryModule,
        ReactiveFormsModule,
        NgSelectModule,
        FormsModule,
        CommonsModule
    ],
  exports: [
    StructureLocationTreeComponent
  ],
  providers: [TreeResolver, StructureService]
})
export class StructureTreeModule { }
